import React, { useReducer } from 'react';

import styled from '@emotion/styled';

import { ChevronDown } from '../Icons/ChevronDown';
import { ChevronUp } from '../Icons/ChevronUp';

// import PlusIcon from '../Icons/PlusIcon';

interface IAccordion {
  title: string;
  children: any;
  handleStateChange?: any;
  index?: number;
  isOpen?: boolean;
}

// Type definition
export enum AccordionReducerActionType {
  CLICKED_SECTION = 'section-clicked',
}

interface IAccordionReducerActionType {
  type: AccordionReducerActionType;
  payload: any;
}

// Reducers
function accordionReducer(state: any, action: IAccordionReducerActionType) {
  switch (action.type) {
    case AccordionReducerActionType.CLICKED_SECTION:
      if (state.index === action.payload.index) {
        return { index: -1 };
      }
      return { ...action.payload };
    default:
      return state;
  }
}

// Components

export const Accordion: React.FC<Pick<IAccordion, 'children'>> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(accordionReducer, {
    index: -1,
  });

  const handleStateChange = (index: any) => {
    dispatch({
      type: AccordionReducerActionType.CLICKED_SECTION,
      payload: { index },
    });
  };

  return (
    <AccordionContainer>
      {React.Children.map(children, (child: any, index) => {
        const isOpen = index === state.index ? true : false;
        return React.cloneElement(child, {
          ...child.props,
          handleStateChange,
          index,
          isOpen,
        });
      })}
    </AccordionContainer>
  );
};

export const AccordionCell: React.FC<IAccordion> = ({
  title,
  children,
  handleStateChange,
  isOpen,
  index,
}) => {
  return (
    <AccordionCellWrapper className={isOpen ? 'revealPadding' : ''}>
      <AccordionLabel onClick={() => handleStateChange(index)}>
        <Label>{title}</Label>
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </AccordionLabel>
      <RevealContent className={isOpen ? 'reveal' : ''}>
        {children}
      </RevealContent>
    </AccordionCellWrapper>
  );
};

// Styles

const AccordionCellWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  color: black;

  &.revealPadding {
    gap: 12px;
  }
`;
const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 18px;

  @media (max-width: 884px) {
    line-height: 24px;
  }
`;

const AccordionLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  @media (max-width: 884px) {
    display: grid;
    grid-template-columns: 1fr 16px;
    gap: 24px;
    align-items: flex-start;
  }
`;

const RevealContent = styled.div`
  display: inline block;
  padding: 0;
  height: 0;
  overflow-y: auto;
  transition: all 0.2s ease;

  font-size: 16px;
  color: #212121;

  &.reveal {
    height: fit-content;
    padding-bottom: 0rem;
  }

  @media (max-width: 884px) {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`;
